import {IUpdateSpinnerLoadingAction} from './types/spinner.action.types';

export const UPDATE_SPINNER_LOADING = 'UPDATE_SPINNER_LOADING';

export const updateSpinnerLoadingAction = (isLoading: boolean): IUpdateSpinnerLoadingAction => ({
    type: UPDATE_SPINNER_LOADING,
    payload: isLoading,
});
